export default __webpack_public_path__ + "static/media/group-motorcycle-dsk.5b1c8a3f.png";